import { useEffect } from "react";
import { Box } from "@mui/material";
import Base from "../../Base/views/Base";
import VisitorsConfiguration from "./VisitorsConfiguration";

const VisitorsSetting = () => {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Base>
      <Box sx={{ height: "calc(100vh - 65px)", overflowY: "auto" }}>
        <VisitorsConfiguration />
      </Box>
    </Base>
  );
};

export default VisitorsSetting;
